module.exports = __webpack_public_path__ + "media/images/providers/eventbrite-c79f535ea35f3ab141dedecbf31f1895.jpg";